import { render, staticRenderFns } from "./hideBox.vue?vue&type=template&id=422e5346&scoped=true"
import script from "./hideBox.vue?vue&type=script&lang=js"
export * from "./hideBox.vue?vue&type=script&lang=js"
import style0 from "./hideBox.vue?vue&type=style&index=0&id=422e5346&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422e5346",
  null
  
)

export default component.exports